import BackButtonToolbar from "features/BackButtonToolbar";
import React from "react";
import {
  ArrayField,
  Datagrid,
  DateField,
  FunctionField,
  Labeled,
  NumberField,
  ReferenceField,
  Show,
  SimpleShowLayout,
  TextField,
} from "react-admin";
import { Grid, useMediaQuery } from "@mui/material";
import { settings } from "app";
import { ScholarshipCategoryChoices, SchorashipTypeChoices } from "utils/choices";
import { Currency } from "utils/constants";
import { studentRequests } from "api/studentApi";
import { SectionTitle } from "features/SectionTitle";

const ShowScholarshipCampaigns = () => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("md"));
  return (
    <Show
      title="Детайли на кампания за стипендии"
      actions={<BackButtonToolbar />}
    >
      <SimpleShowLayout>
        <SectionTitle
          title="Информация"
          textAlign="center"
          sx={{ marginTop: "2rem" }}
        />
        <Grid
          container
          spacing={3}
          sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
        >
          <Grid
            item
            xs={12}
            md={3}
          >
            <Labeled label="Име на български">
              <TextField source="nameBg" />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={3}
          >
            <Labeled label="Име на английски">
              <TextField source="nameEn" />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={3}
          >
            <Labeled label="Учебна година">
              <ReferenceField
                source="academicYearId"
                reference={studentRequests.getAcademicYearsSelect()}
              >
                <TextField source="name" />
              </ReferenceField>
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={3}
          >
            <Labeled label="Семестър">
              <ReferenceField
                source="sessionType"
                reference={studentRequests.getAcademicSessionTypesSelect()}
              >
                <TextField source="name" />
              </ReferenceField>
            </Labeled>
          </Grid>
        </Grid>
        <SectionTitle
          title="Кандидатстване"
          textAlign="center"
          sx={{ marginTop: "2rem" }}
        />
        <Grid
          container
          spacing={3}
          sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
        >
          <Grid
            item
            xs={12}
            md={3}
          >
            <Labeled label="Начална дата">
              <DateField
                source="applicationStartDate"
                locales="bg-BG"
              />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={3}
          >
            <Labeled label="Крайна дата">
              <DateField
                source="applicationEndDate"
                locales="bg-BG"
              />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={3}
          >
            <Labeled label="Брой семестри за среден успех">
              <TextField source="semestersForGradeCalculation" />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={3}
          >
            <Labeled label="Правила и условия">
              <TextField source="termsAndConditions" />
            </Labeled>
          </Grid>
        </Grid>
        <SectionTitle
          title="Доход"
          textAlign="center"
          sx={{ marginTop: "2rem" }}
        />
        <Grid
          container
          spacing={3}
          sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
        >
          <Grid
            item
            xs={12}
            md={4}
          >
            <Labeled label="Средно месечен доход за член на семейството">
              <TextField source="maxIncomePerFamilyMember" />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={4}
          >
            <Labeled label="Начална дата за предоставяне на документ">
              <DateField
                source="familyIncomeStartDate"
                locales="bg-BG"
              />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={4}
          >
            <Labeled label="Крайна дата за предоставяне на документ">
              <DateField
                source="familyIncomeEndDate"
                locales="bg-BG"
              />
            </Labeled>
          </Grid>
        </Grid>
        <SectionTitle
          title="Скали"
          textAlign="center"
          sx={{ marginTop: "2rem" }}
        />
        <Grid
          container
          spacing={3}
          sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
        >
          <Grid
            item
            xs={12}
            md={6}
          >
            <ArrayField
              source="incomeScales"
              label=""
            >
              <Datagrid
                rowClick={false}
                bulkActionButtons={false}
                sx={settings.style.detailsDatagrid}
              >
                <NumberField
                  source="lowerLimit"
                  label="Долна граница (Доход)"
                  textAlign="left"
                  options={{
                    style: "currency",
                    currency: Currency.BGN,
                  }}
                />
                <TextField
                  source="points"
                  label="Точки"
                />
              </Datagrid>
            </ArrayField>
          </Grid>
          <Grid
            item
            xs={12}
            md={6}
          >
            <ArrayField
              source="gradeScales"
              label=""
            >
              <Datagrid
                rowClick={false}
                bulkActionButtons={false}
                sx={settings.style.detailsDatagrid}
              >
                <NumberField
                  source="lowerLimit"
                  label="Долна граница (Оценка)"
                  textAlign="left"
                />
                <TextField
                  source="points"
                  label="Точки"
                />
              </Datagrid>
            </ArrayField>
          </Grid>
        </Grid>
        <SectionTitle
          title="Стипендии"
          textAlign="center"
          sx={{ marginTop: "2rem" }}
        />
        <Grid
          container
          spacing={3}
          sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
        >
          <Grid
            item
            xs={12}
          >
            <ArrayField
              source="scholarships"
              label=""
            >
              <Datagrid
                rowClick={false}
                bulkActionButtons={false}
                sx={settings.style.detailsDatagrid}
              >
                <FunctionField
                  render={record => SchorashipTypeChoices.find(option => option.id === record.type)?.name}
                  label="Тип стипендия"
                />
                <FunctionField
                  render={record => ScholarshipCategoryChoices.find(option => option.id === record.category)?.name}
                  label="Категория стипендия"
                />
                <NumberField
                  source="amount"
                  label="Сума"
                />
                <TextField
                  source="description"
                  label="Описание"
                />
              </Datagrid>
            </ArrayField>
          </Grid>
        </Grid>
      </SimpleShowLayout>
    </Show>
  );
};

export default ShowScholarshipCampaigns;
